module.exports = __webpack_public_path__ + "static/media/a.c27b14b9.jpg";